import { Accordion, AccordionDetails, Typography, useEventCallback } from '@mui/material';
import { memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { ExpandMore } from '@mui/icons-material';
import BirthdayDocumentForm from './form';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import { BirthdayDocument as BirthdayDocumentVM } from 'shell/view-models/birthday-document';
import { NewPersonVM } from 'shell/components/shared/sipo-person-form/new-person';

interface BirthdayDocumentProps {
  isEdit?: boolean;
}

const BirthdayDocumentComponent = ({ isEdit }: BirthdayDocumentProps): React.ReactElement => {
  const [open, setOpen] = useState(false);

  const formContext = useFormikContext<NewPersonVM>();

  const onFieldBirthdayDocumentChange = useEventCallback(
    (key: keyof BirthdayDocumentVM, value: BirthdayDocumentVM[keyof BirthdayDocumentVM]) => {
      formContext.setFieldValue('birthdayDocument', {
        ...formContext.values.birthdayDocument,
        [key]: value,
      });
    }
  );

  const resetForm = useEventCallback(() => {
    formContext.setFieldValue('birthdayDocument', { transcript: false });
  });

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-birthday-document-content"
        id="panel-person-birthday-document-header"
        expandIcon={<ExpandMore />}
      >
        <Typography>
          Atto di nascita
          {formContext?.errors?.birthdayDocument && formContext?.touched?.birthdayDocument ? (
            <Typography style={{ color: '#d6012e', display: 'inline', paddingLeft: '10px' }}>
              Attenzione verificare dati errati o mancanti
            </Typography>
          ) : undefined}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <BirthdayDocumentForm
          onChange={onFieldBirthdayDocumentChange}
          values={formContext.values.birthdayDocument}
          errors={formContext.errors.birthdayDocument as FormikErrors<BirthdayDocumentVM>}
          touched={formContext.touched.birthdayDocument as FormikTouched<BirthdayDocumentVM>}
          onChangeValues={resetForm}
          disabled={isEdit}
          birthday={formContext.values.generality?.birthDate}
        />
      </AccordionDetails>
    </Accordion>
  );
};

BirthdayDocumentComponent.displayName = 'Accordion Birthday document component';

const BirthdayDocument = memo(BirthdayDocumentComponent);

export default BirthdayDocument;
